module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"There is no live yet":"There is no live yet"},"zh":{"There is no live yet":"还没有直播间哦"}}')
  delete Component.options._Ctor
}
